import _ from 'lodash';
import { FemaGoModal } from 'app-ui-componentlibrary';
import { PERMISSIONS_MAP_INTERNAL, REGIONAL_ROLE_MAP_INTERNAL, ROLE_MAP_INTERNAL } from 'go/components/organization/team/constants';
import React, { useState } from 'react';
import { Icon, Message, Popup } from 'semantic-ui-react';

export const RolesAndPermissionsMessage = ({ eligibleRoleIds }) => {
    const tags = _.map(
        _.orderBy(_.uniqBy(_.map(eligibleRoleIds, roleId => _.get(REGIONAL_ROLE_MAP_INTERNAL, roleId, _.get(ROLE_MAP_INTERNAL, roleId))))),
        roleName => {
            return (
                <div key={roleName}>
                    <strong>{roleName}</strong> - {_.get(PERMISSIONS_MAP_INTERNAL, roleName)}
                </div>
            )
        });

    return (
        <Message
            info
            icon="info blue circle"
            color="blue"
            content={tags}
            header="Role permissions:"
        />
    );
}

const RolesAndPermissionsPopup = ({ eligibleRoleIds }) => {
    const [modalOpen, setModalOpen] = useState(false);

    return (
        <>
            <FemaGoModal
                title=""
                size="medium"
                open={modalOpen}
                confirmButton="hidden"
                cancelAction={() => setModalOpen(false)}
            >
                <RolesAndPermissionsMessage eligibleRoleIds={eligibleRoleIds} />
            </FemaGoModal>
            <a
                data-content="Roles and Perms"
                color="blue"
                className="rolesAndPermissions"
                style={{ fontSize: '12px' }}
                href="#"
                onClick={(e) => {
                    e.preventDefault();
                    setModalOpen(true);
                }}
            >
                <Popup
                    hideOnScroll
                    hoverable
                    position="bottom center"
                    wide="very"
                    content={<RolesAndPermissionsMessage eligibleRoleIds={eligibleRoleIds} />}
                    trigger={
                        <div>
                            <Icon
                                name="info circle"
                                color="blue"
                                label="Roles & permissions"
                                title="Roles & permissions"
                            />
                            <strong label="Roles & permissions">
                                {'Roles & permissions'}
                            </strong>
                        </div>
                    }
                />
            </a>
        </>
    )
}

export default RolesAndPermissionsPopup;